import { breakpoints } from '@chegg-ui/theme';
import { ProductType } from '@chegg/checkout-sdk';
import { Component, Components, fireLogEvent, fireStatusUpdate, Namespace, OneClickCommandNames, SpecType, StatusTypes, UserActions, sendRioEvent } from '@chegg/commerce-utils';
import { SECONDARY_CTA_COUNTRIES } from '../../constants/appConstants';
import { sendNewRelicError } from '../../utils/NewRelicUtils';
import { sendResubscribeRio2Event } from '../../utils/RioEvents';

/**
 *  Sets component state for device type
 */
var onScreenSizeChange;
export function setupMediaQuery(setIsMobile, allowPlanSelection) {
  var queryString = "(max-width: ".concat(allowPlanSelection ? breakpoints.md.min : breakpoints.md.max, ")");
  var mediaQuery = window.matchMedia(queryString);
  setIsMobile(mediaQuery.matches);
  onScreenSizeChange = function onScreenSizeChange(ev) {
    setIsMobile(ev.matches);
  };
  mediaQuery.addEventListener('change', onScreenSizeChange);
}
export function removeMediaQuery() {
  var mediaQuery = window.matchMedia("(max-width: ".concat(breakpoints.md.max, ")"));
  mediaQuery.removeEventListener('change', onScreenSizeChange);
}
export function getPaymentMethodsHeadingText(isReviewStep, text) {
  return isReviewStep ? '' : text;
}

/**
 *  Boolean indicating whether to show a secondary CTA based on the provided country
 */
export var showSecondaryCTA = function showSecondaryCTA(country) {
  return SECONDARY_CTA_COUNTRIES.includes(country);
};

/**
 *  Send pageview and component view Rio events when CartCheckout loads, dependings on user action (join, upgrade, resubscribe)
 */

export var sendComponentLoadedEvent = function sendComponentLoadedEvent(_ref) {
  var action = _ref.action,
    namespace = _ref.namespace,
    externalId = _ref.externalId,
    productData = _ref.productData,
    _ref$sendRioViewEvent = _ref.sendRioViewEvents,
    sendRioViewEvents = _ref$sendRioViewEvent === void 0 ? true : _ref$sendRioViewEvent;
  var componentName = action === UserActions.JOIN ? Components.ONE_CLICK_SUBSCRIBE : Components.ONE_CLICK_RESUBSCRIBE;
  sendResubscribeRio2Event(action, productData);
  sendRioEvent({
    info: "".concat(componentName, " Component Loaded"),
    specType: SpecType.COMPONENT_VIEW,
    callback: fireLogEvent,
    namespace: namespace,
    product_details: [productData],
    force: false
  });
  if (sendRioViewEvents) {
    sendClickstreamViewEvent({
      action: action,
      namespace: namespace,
      externalId: externalId
    });
  }
};
export var sendClickstreamViewEvent = function sendClickstreamViewEvent(params) {
  var action = params.action,
    namespace = params.namespace,
    externalId = params.externalId;
  // TODO: Remove after CS endgame
  // Page Views rio events firing for CS team
  switch (action) {
    case UserActions.JOIN:
      sendRioEvent({
        info: Components.ONE_CLICK_SUBSCRIBE,
        specType: SpecType.PAGE_VIEW,
        callback: fireLogEvent,
        namespace: namespace,
        force: false
      });
      break;
    case UserActions.UPGRADE:
      sendRioEvent({
        info: Components.ONE_CLICK_UPGRADE,
        specType: SpecType.PAGE_VIEW,
        callback: fireLogEvent,
        namespace: namespace,
        force: false
      });
      break;
    case UserActions.RESUBSCRIBE:
      sendRioEvent({
        info: Components.ONE_CLICK_RESUBSCRIBE,
        specType: SpecType.PAGE_VIEW,
        callback: fireLogEvent,
        namespace: namespace,
        force: false
      });
      break;
    default:
      sendNewRelicError("".concat(action, " not supported"), {
        externalId: externalId,
        action: action
      });
  }
};

/**
 *  Fires status update when secondary CTA button is clicked
 */
export var onSecondaryClickHandler = function onSecondaryClickHandler() {
  fireStatusUpdate([{
    command: OneClickCommandNames.EXIT_ONE_CLICK,
    status: StatusTypes.SUCCESS,
    payload: {
      component: Component.CART_CHECKOUT,
      data: {
        action: 'clicks back'
      }
    }
  }], Namespace.ONE_CLICK);
};

/**
 * Determines if CSP resub user is eligible for pithy value props experiment
 * https://chegg.atlassian.net/browse/SQUAA-930
 */
export var getIsEligibleForPithyValueProps = function getIsEligibleForPithyValueProps(country, action, productType) {
  return country === 'US' && action === UserActions.RESUBSCRIBE && productType === ProductType.BUNDLE;
};
export var getMonthlyBasePrice = function getMonthlyBasePrice(pricing) {
  var _pricing$eligibility$;
  return pricing === null || pricing === void 0 || (_pricing$eligibility$ = pricing.eligibility.pricePlans) === null || _pricing$eligibility$ === void 0 || (_pricing$eligibility$ = _pricing$eligibility$.quoteItems) === null || _pricing$eligibility$ === void 0 || (_pricing$eligibility$ = _pricing$eligibility$.priceQuoteItems) === null || _pricing$eligibility$ === void 0 ? void 0 : _pricing$eligibility$[0].monthlyBasePrice;
};
export var getSavingsPercentage = function getSavingsPercentage(pricing) {
  var _pricing$eligibility$2;
  return Number(pricing === null || pricing === void 0 || (_pricing$eligibility$2 = pricing.eligibility.pricePlans) === null || _pricing$eligibility$2 === void 0 || (_pricing$eligibility$2 = _pricing$eligibility$2.quoteItems) === null || _pricing$eligibility$2 === void 0 || (_pricing$eligibility$2 = _pricing$eligibility$2.priceQuoteItems) === null || _pricing$eligibility$2 === void 0 ? void 0 : _pricing$eligibility$2[0].totalSavingsPercentage) || 0;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/helpers.js
// module id = 386
// module chunks = 11